/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useRef, useState } from "react";
import Icon, { CloseCircleOutlined, UpOutlined, LoadingOutlined } from "@ant-design/icons";
import { useLazyQuery, useQuery } from "@apollo/client";
import { Button, Spin, Input, Popover, Skeleton, Switch, Tooltip } from "antd";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import { UserContext } from "../../../amplify/authenticator-provider";
import { GET_AI_RESPONSE, GET_AI_SUGGESTION_QUICK_TIP } from "../../../graphql/query";
import { applicationUseCaseMapping, getApplicationUseCaseId } from "../../../library/utils";
import { ADDING_TYPE } from "../../adminDashboard/settings/CustomizeAiSuggestions";
import CustomSkeleton from "../../commonComponents/CustomSkeleton";
import "./editor.css";
import { isAllLocationSelected } from "../../../library/helpers";
import { setTextAiResponseHistoryId } from "../../../redux/slices/aiSlice";

export function SuggestAMessageButton({
  createSuggestedResponse,
  misc,
  selectedLead,
  disabled,
  text,
  setinputText,
  setloaderFn,
  postId = null,
  socialReviewId = null,
  code = null,
}) {
  const popupRef = useRef(null);
  const { user } = useContext(UserContext);
  const [visibleCustomizedAiPopup, setVisibleCustomizedAiPopup] = useState(false);
  const [customizePromptData, setcustomizePromptData] = useState({
    visible: false,
    quickTips: [],
    tones: [],
    additionalNote: "",
  });

  return (
    <>
      {misc.loading && <Spin indicator={<LoadingOutlined spin />} className="m-1" />}
      <div
        key={selectedLead?.id}
        className="flex bg-white border border-solid border-[#E2E8F0] rounded flex-row items-stretch"
        style={{
          opacity: disabled || misc.loading ? 0.5 : 1,
          pointerEvents: disabled || misc.loading ? "none" : "auto",
        }}
      >
        <Tooltip title="Suggest message" disabled={misc.loading}>
          <div
            className="flex items-center justify-center w-[30px] h-[30px] cursor-pointer"
            onClick={() => {
              if (text?.current) {
                setinputText && setinputText("");
                text.current.placeholder = "Generating response...";
                text.current.value = "";
                text.current.style.height = "0px";
                text.current.focus();
              }
              !misc.loading && createSuggestedResponse();
            }}
          >
            <Icon component={EngagedAI} alt="EngagedAi" style={{ fontSize: "20px" }} />
          </div>
        </Tooltip>
        <div className="self-stretch w-[1px] bg-[#E2E8F0]" />
        <Tooltip title="Customize AI Suggestion">
          <Popover
            overlayClassName="ai-prompt-popup"
            trigger={["click"]}
            content={
              <CustomizePrompt
                user={user}
                text={text}
                selectedLead={selectedLead}
                customizePromptData={customizePromptData}
                setcustomizePromptData={setcustomizePromptData}
                popupRef={popupRef}
                setinputText={setinputText}
                setloaderFn={setloaderFn}
                setVisibleCustomizedAiPopup={setVisibleCustomizedAiPopup}
                postId={postId}
                socialReviewId={socialReviewId}
                applicationUseCaseId={code}
              />
            }
          >
            <div
              className="flex items-center justify-center w-[30px] h-[30px] cursor-pointer"
              ref={popupRef}
              onClick={e => {
                e.preventDefault();
                setcustomizePromptData({ ...customizePromptData, visible: true });
                setVisibleCustomizedAiPopup(true);
              }}
              onBlur={() => {
                setVisibleCustomizedAiPopup(true);
              }}
            >
              <UpOutlined
                className={`text-[#64748B] text-[14px] ${
                  visibleCustomizedAiPopup ? "rotate-0" : "rotate-180"
                } transition duration-300`}
              />
            </div>
          </Popover>
        </Tooltip>
      </div>
    </>
  );
}

const CustomizePrompt = ({
  setcustomizePromptData,
  customizePromptData,
  selectedLead,
  user,
  text,
  popupRef,
  setinputText,
  setloaderFn,
  postId = null,
  socialReviewId = null,
  applicationUseCaseId = applicationUseCaseMapping.ENGAGEMENT_MESSAGE_SUGGESTION,
  selectedOppTypeId = null,
}) => {
  const Divider = () => <div className="w-full h-[2px] bg-grey-200 " />;
  const SectionHeader = ({ children }) => (
    <span className="text-sm font-[400] text-grey-700">{children}</span>
  );
  const Toggle = ({ children, onChange, value }) => (
    <div className="flex gap-1 flex-row items-center">
      <Switch onChange={onChange} checked={value} size="small" /> {children}
    </div>
  );

  const [dynamicTips, setdynamicTips] = useState([]);
  const [dynamicTones, setdynamicTones] = useState([]);
  const [isEnableAdditionalComments, setisEnableAdditionalComments] = useState(false);
  const { applicationUseCases } = useSelector(state => state.aiData);
  const { messageOpportunity } = useSelector(state => state.lead);
  const dispatch = useDispatch();

  const [getAiResponse, { loading: getAiResponseLoader }] = useLazyQuery(GET_AI_RESPONSE, {
    nextFetchPolicy: "network-only",
  });

  const { loading: quickTipLoader } = useQuery(GET_AI_SUGGESTION_QUICK_TIP, {
    // Default ``cache-first`` policy: re-opening the popover for the
    // same (location, tab, use-case) combo returns cached results
    // without a network call. Tab switch invalidates the cache key
    // naturally via ``rootOppTypeId``.
    variables: {
      companyId: user.company.id,
      // With an active tab, defer to BE's department-derivation by
      // ``rootOppTypeId``. Without one, keep the legacy
      // ``user.departmentIds`` path.
      locationIds:
        !selectedOppTypeId && Array.isArray(user?.departmentIds) && user.departmentIds.length > 0
          ? null
          : !isAllLocationSelected()
          ? sessionStorage.getItem("currentLocationId")
          : isAllLocationSelected()
          ? user?.location?.id
          : null,
      applicationUseCaseId: getApplicationUseCaseId(applicationUseCases, applicationUseCaseId)?.id,
      departmentIds: selectedOppTypeId ? null : user?.departmentIds || null,
      rootOppTypeId: selectedOppTypeId || null,
    },
    onCompleted: res => {
      // filter out active tips only
      const activeTips = (res?.getAiSuggestionQuickTip || [])?.filter(
        tip => tip?.isActive && tip?.suggestionType === ADDING_TYPE.TIPS
      );

      // filter out active tones only
      const activeTones = (res?.getAiSuggestionQuickTip || [])?.filter(
        tip => tip?.isActive && tip?.suggestionType === ADDING_TYPE.TONES
      );

      // filter out active additional comments only
      const additionalComments = (res?.getAiSuggestionQuickTip || [])?.filter(
        tip => tip?.isActive && tip?.suggestionType === ADDING_TYPE.ADDITIONAL_NOTES
      );

      setdynamicTips(activeTips);
      setdynamicTones(activeTones);
      setisEnableAdditionalComments(additionalComments.length > 0);
    },
  });

  const close = () => popupRef.current.click();

  const getAiResponseHandler = async () => {
    if (text?.current) {
      setinputText && setinputText("");
      text.current.placeholder = "Generating response...";
      text.current.value = "";
      text.current.style.height = "0px";
      text.current.focus();
    }
    const promptData = { ...customizePromptData };
    delete promptData.visible;
    const payload = {
      aiSuggestionUserInput: { ...promptData },
      leadId: selectedLead?.id,
      companyId: user?.company?.id,
      applicationUseCaseId: getApplicationUseCaseId(applicationUseCases, applicationUseCaseId)?.id,
      postId: postId,
      socialReviewId: socialReviewId,
      leadOpportunityId: messageOpportunity === "#DEFAULTOPPID" ? null : +messageOpportunity,
    };

    setloaderFn(true);
    const res = await getAiResponse({
      variables: payload,
      fetchPolicy: "network-only",
    });

    dispatch(setTextAiResponseHistoryId(res?.data?.getAiResponse?.aiResponseHistoryId));

    const writeText = res?.data?.getAiResponse?.content || "No response received";

    let index = 0;

    if (!isEmpty(writeText)) {
      typeCharacter();
    } else {
      setloaderFn(false);
    }

    function typeCharacter() {
      if (index < writeText.length) {
        if (!isEmpty(text?.current)) {
          text.current.style.height = `${text.current.scrollHeight}px`;
          if (isEmpty(text?.current?.value)) {
            text.current.value = writeText.charAt(index);
          } else {
            text.current.value += writeText.charAt(index);
          }
          index++;
          if (index === writeText.length) {
            setinputText && setinputText(writeText);
            setloaderFn(false);
          }
          setTimeout(typeCharacter, 20); // Adjust the delay (in milliseconds) between characters here
        }
      }
    }
    // text.current.value
    close();
  };
  return (
    <div className="flex flex-col" onClick={e => e.stopPropagation()}>
      <div className="flex flex-row p-3 bg-[#F1F5F9] justify-between">
        <span className="text-sm font-[600] text-grey-700 ">Customize AI Suggestion</span>
        <CloseCircleOutlined onClick={() => close()} className="cursor-pointer" />
      </div>
      <div className="flex flex-col py-2 px-4 items-start ">
        <SectionHeader>Quick Tips</SectionHeader>
        <div className="flex flex-col w-full gap-1">
          {quickTipLoader ? (
            <CustomSkeleton />
          ) : !isEmpty(dynamicTips) ? (
            dynamicTips.map((item, index) => (
              <Toggle
                key={index}
                onChange={checked => {
                  if (checked) {
                    setcustomizePromptData(prev => {
                      const temp = { ...prev };
                      temp.quickTips.push(item.tip);
                      return temp;
                    });
                  } else {
                    setcustomizePromptData(prev => {
                      const temp = structuredClone(prev);
                      const index = temp.quickTips.indexOf(item.tip);
                      temp.quickTips.splice(index, 1);
                      return temp;
                    });
                  }
                }}
                value={customizePromptData.quickTips.includes(item.tip)}
              >
                {item.tip}
              </Toggle>
            ))
          ) : (
            <span className="text-sm text-grey-600">Quick tips are not available</span>
          )}
        </div>
      </div>
      <Divider />
      <div className="flex flex-col py-2 px-4 items-start">
        <SectionHeader>Tone</SectionHeader>
        <div className="flex flex-row flex-wrap gap-1">
          {quickTipLoader ? (
            <CustomSkeleton skeletonCount={1} />
          ) : !isEmpty(dynamicTones) ? (
            dynamicTones.map((item, index) => (
              <Toggle
                key={index}
                onChange={checked => {
                  if (checked) {
                    setcustomizePromptData(prev => {
                      const temp = { ...prev };
                      temp.tones = [item.tip];
                      return temp;
                    });
                  } else {
                    setcustomizePromptData(prev => {
                      const temp = { ...prev };
                      temp.tones = [];
                      return temp;
                    });
                  }
                }}
                value={customizePromptData.tones.includes(item.tip)}
              >
                {item.tip}
              </Toggle>
            ))
          ) : (
            <span className="text-sm text-grey-600">Tones are not available</span>
          )}
        </div>
      </div>
      <Divider />
      <div className="flex flex-col py-2 gap-1 px-4 items-start">
        {quickTipLoader ? (
          <CustomSkeleton skeletonCount={1} skeletonHeight="2rem" />
        ) : (
          isEnableAdditionalComments && (
            <>
              <SectionHeader>Additional Notes</SectionHeader>
              <Input.TextArea
                value={customizePromptData.additionalNote}
                onChange={e =>
                  setcustomizePromptData({ ...customizePromptData, additionalNote: e.target.value })
                }
                autoSize={{ minRows: 3 }}
                placeholder="Type some notes..."
              />
            </>
          )
        )}
        {/* <Checkbox
          checked={customizePromptData.save}
          onChange={e => setcustomizePromptData({ ...customizePromptData, save: e.target.checked })}
        >
          Save these options
        </Checkbox>
        {customizePromptData.save && (
          <Input
            value={customizePromptData.filterName}
            onChange={e =>
              setcustomizePromptData({ ...customizePromptData, filterName: e.target.value })
            }
            placeholder="Enter preset customize name"
          />
        )} */}
        <Button
          loading={getAiResponseLoader}
          onClick={getAiResponseHandler}
          type="primary"
          className="w-full rounded-sm mt-2"
        >
          Regenerate
        </Button>
      </div>
    </div>
  );
};
